<template>
  <div :class="{'meeting-room':true}">
   <div class="top">
     <h1>会议室预订</h1>
     <img :src="lineUrl"/>
     <p>随时随地预约会议资源，智能高效，使会议室资源利用率最大化。</p>
   </div>
   <div class="meeting-room-footer">
        <div class="meeting-room-item">
          <div :class="{'background-style':true,'fixed-back-class':backFixed}">

          </div>
          <div class="left item-part" >
            <div class="float-right">
              <h1>预订前</h1>
              <p>用户随时随地可通过NOVOBIT小程序查看会议室，预订信息，会议室门禁显示屏幕也会展示当天会议室的预订情况。</p>
            </div>
          </div>
          <div :class="{'right':true,'item-part':true,'fixed-class':imgboxFixed}" v-show="showItem1">
            <div class="fix-inner">
              <img :src="leisureUrl" class="device">
              <img :src="leisurePhoneUrl" class="hand">
            </div>
          </div>
        </div>

        <div class="meeting-room-item">
         
          <div class="left item-part" >
            <div class="float-right">
              <h1>预订</h1>
              <p>只需在小程序上选择需要预订的会议室，完成会议信息的填写即可成功预订该会议室。</p>
            </div>
          </div>
          <div :class="{'right':true,'item-part':true,'fixed-class':imgboxFixed}" v-show="showItem2">
            <div class="fix-inner">
              <img :src="leisureUrl" class="device">
              <img :src="inmeetingPhoneUrl" class="hand">
            </div>
          </div>
        </div>

        <div class="meeting-room-item">
          <div :class="{'background-style':true,'fixed-back-class':backFixed}" v-show="showlastItemBack">

          </div>
          <div class="left item-part" >
            <div class="float-right">
              <h1>预订后</h1>
              <p>小程序首页及我的页面会展示已预订的会议室信息，在预订时间段内会议室门禁显示屏展示“会议中”的状态。</p>
            </div>
          </div>
          <div :class="{'right':true,'item-part':true,'fixed-class':imgboxFixed}"  v-show="showItem3">
            <div class="fix-inner">
              <img :src="inmeetingUrl" class="device">
              <img :src="leisurePhoneUrl" class="hand">
            </div>
          </div>
        </div>
        

       
   </div>
  </div>
</template>

<script>
  
  import lineUrl from 'common/image/home/smart-door/line.png';
  import leisureUrl from 'common/image/home/meeting-room/leisure.png';
  import inmeetingUrl from 'common/image/home/meeting-room/inmeeting.png';
  import leisurePhoneUrl from 'common/image/home/meeting-room/leisure-phone.png';
  import inmeetingPhoneUrl from 'common/image/home/meeting-room/inmeeting-phone.png';
  import { setTimeout } from 'timers';

  export default {
    name: "MeetingRoom",
    components: {

    },
    data() {
      return {
        leisureUrl,inmeetingUrl,leisurePhoneUrl,inmeetingPhoneUrl,lineUrl,
    
        clientHeight : 0,
        mouseScroolUp : true,
        imgboxFixed: false,
        showItem1:true,
        showItem2:true,
        showItem3:true,
        showBackground : false,
        backFixed:false,
        showlastItemBack : false,

      };
    },
    mounted() {
      this.setItemHeight();

      this.meetingroomDom = document.getElementsByClassName('meeting-room-footer')[0];
      document.addEventListener('scroll', this.handleBodyScroll);
    },
    
    beforeDestroy(){
      //  chrome and ie
      window.removeEventListener('mousewheel',this.handleMouseScroll);
      // firefox
      window.removeEventListener("DOMMouseScroll",this.handleMouseScroll);

      document.removeEventListener('scroll', this.handleScroll);


      // this.removeMouseScroll();
      document.removeEventListener('scroll', this.handleBodyScroll);
      // this.allRemoverMous();
    },
    methods: {
      setItemHeight(){
        // 获取浏览器可视区域高度
        this.clientHeight =   window.innerHeight; 
        window.onresize = function temp() {
          this.clientHeight = window.innerHeight;
        };
        this.containerItems = document.getElementsByClassName('meeting-room-item')
        for(let i=0;i<this.containerItems.length;i++){
          this.containerItems[i].style.height = this.clientHeight + "px";
        }
      },
      handleBodyScroll(event){

        var toTopHeight =  this.meetingroomDom.getBoundingClientRect().top;

        var imgBox = document.getElementsByClassName("img-box")[0];
        if(toTopHeight<0 && toTopHeight>-(this.clientHeight*2) ){
          // imgBox
          this.imgboxFixed = true; 


          if(toTopHeight<0 && toTopHeight>-(this.clientHeight/2)){
            this.showItem1 = true;
            this.showItem2 = false;
            this.showItem3 = false;
          }else if(toTopHeight <= -(this.clientHeight/2) && toTopHeight>-(3*this.clientHeight/2)){
            this.showItem1 = false;
            this.showItem2 = true;
            this.showItem3 = false;
          }else if(toTopHeight<=-(3*this.clientHeight/2) && toTopHeight>=-(this.clientHeight*2)){

            this.showItem1 = false;
            this.showItem2 = false;
            this.showItem3 = true;
          }
        }else{

          this.imgboxFixed = false; 
          this.showItem1 = true;
          this.showItem2 = true;
          this.showItem3 = true;
        }
        if(toTopHeight<0 && toTopHeight>-(this.clientHeight*2)){
           this.backFixed = true;
           this.showlastItemBack = false;
        }else{
          this.backFixed = false;
          this.showlastItemBack = true;
        }

      
      },
      
     
    
    
     
     
    }

  }
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 
  .meeting-room{
    // height:814px;
    .top{
      padding-top:60px;
      text-align: center;
      h1{
        font-family: DFPKingGothicGB-Regular;
        font-size: 24px;
        color: #000000;
        text-align: center;
        // font-weight: 400;
        font-weight: bold;
      }
      img{
        width:30px;
        height:8px;
        margin:15px 0 16px 0;
      }
      p{
        font-family: DFPKingGothicGB-Light;
        font-size: 18px;
        color: #000000;
      }
    }
    .meeting-room-footer{
      
        .meeting-room-item{
          .background-style{
            position: absolute;
            top: 50%;
            width: 100%;
            height: 230px;
            margin-top: -115px;
            background-image: linear-gradient(-135deg, #3CA9FF 0%, #7CE1FF 100%);
            opacity: 0.3;
          }
          position: relative;
          .item-part{
            display: inline-block;
            
            height: 100%;
          }
          .left{
            width:40%;
            position: relative;
            .float-right{
              position: absolute;
              top: 50%;
              right:0;
              transform:translate(0,-50%);
            }
            h1{
              width:290px;
              font-family: DFPKingGothicGB-Regular;
              font-size: 24px;
              color: #000000;
              font-weight: 400;
              font-weight: bold;
              line-height: 42px;
            }
            p{
              display: inline-block;
              width:290px;
              font-family: DFPKingGothicGB-Light;
              font-size: 18px;
              color: #000000;
              text-align: justify;
              line-height: 36px;
            }
          }
          
          .right{
            width:60%;
            padding-left:70px;
            position:absolute;
            right:0;
            font-size: 0;
            top:50%;
            transform: translate(0,-50%);
            .device{
              width:208px;
              height:463px;
              margin-right:59px;
            }
            .hand{
               width:328px;
              height:463px;
            }
            .fix-inner{
              position: absolute;
              top: 50%;
              transform: translate(0,-50%);
            }
          }
          .fixed-class{
            position: fixed;
            width: 60%;
            height: 100%;
            .fix-inner{
              width:1000px;
              position: absolute;
              
            }
          }
          .fixed-back-class{
            position: fixed;
          }
        }
        .item-2{
          .left{
            padding: 20px 0;
          }
        }
      }  
  }
  .fix-plane{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 100;
    background: #fff;
  }
  @keyframes movoText
    {
      from {top:80%;}
      to {top:50%;}
    }
    



</style>
<style  lang="scss">
  .meeting-page-box{
    width:12px;
    height:180px;
    background: url("~common/image/home/meeting-room/step.png") top / 70% 100%  no-repeat;
    position: relative;
    top:52%;
    transform: translate(0,-50%);
    border-radius: 6px;
    padding: 20px 0; 
    .circle-box{
      width:12px;
      height:140px;
      position: relative;
      .circle{
        position: absolute;
        width:12px;
        height:20px;
        background: url("~common/image/home/meeting-room/hollow-circle.png") top / 100% 100%  no-repeat;
      }
      .circle-2{
        top:50%;
        transform: translate(0,-50%)
      }
      .circle-3{
        bottom:0;
      }

    }
   
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/meeting-room/index.vue